import { useMemo } from 'react';
import { dbui_v1_TransformRequest } from '@antimatterhq/asl-api-ts-v1';
import { useGetTransform } from '../dbui/useGetTransform';
import { useGetTransformStatus } from '../dbui/useGetTransformStatus';
import { prettifyTransformErrorMessage } from '@/utils/error';

export const useGetAndPollTransform = (
  transformRequest: dbui_v1_TransformRequest,
  enabled: boolean,
) => {
  const {
    data: transformResponse,
    isFetching: isFetchingTransform,
    error: transformResponseError,
  } = useGetTransform(transformRequest);

  const {
    data: transformStatusResponse,
    isFetching: isFetchingTransformStatus,
    error: transformStatusResponseError,
  } = useGetTransformStatus(
    enabled && transformResponse?.status === 'running'
      ? transformResponse?.id || ''
      : '',
  );

  const isLoading = useMemo(() => {
    return isFetchingTransform || isFetchingTransformStatus;
  }, [isFetchingTransform, isFetchingTransformStatus]);

  const stages = useMemo(() => {
    return (
      transformResponse?.result?.stages ||
      transformStatusResponse?.result?.stages
    );
  }, [transformResponse, transformStatusResponse]);

  const error = useMemo(() => {
    const transformResponseErrorMessage = prettifyTransformErrorMessage(
      transformResponseError,
    );

    const transformStatusResponseErrorMessage = prettifyTransformErrorMessage(
      transformStatusResponseError,
    );

    const errorMessage =
      transformResponse?.error ??
      transformStatusResponse?.error ??
      transformResponseErrorMessage ??
      transformStatusResponseErrorMessage ??
      undefined;

    return errorMessage;
  }, [
    transformResponse,
    transformStatusResponse,
    transformResponseError,
    transformStatusResponseError,
  ]);

  return {
    stages,
    isLoading,
    error,
  };
};
